<script setup lang="ts">
  import {
    SwitchRoot,
    type SwitchRootEmits,
    type SwitchRootProps,
    SwitchThumb,
    useForwardPropsEmits,
  } from 'reka-ui'
  import { type HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { cn } from '@rapoo/element/lib/utils'
  import { switchThumbVariants, switchVariants, type SwitchVariants } from '.'

  const props = defineProps<
    SwitchRootProps & {
      class?: HTMLAttributes['class']
      size?: SwitchVariants['size']
      thumbClass?: HTMLAttributes['class']
    }
  >()

  const emits = defineEmits<SwitchRootEmits>()

  const delegatedProps = reactiveOmit(props, 'class', 'size')

  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <SwitchRoot v-bind="forwarded" :class="cn(switchVariants({ size }), props.class)">
    <SwitchThumb :class="cn(switchThumbVariants({ size }), props.thumbClass)">
      <slot name="thumb" />
    </SwitchThumb>
  </SwitchRoot>
</template>
